module.exports = __webpack_public_path__ + "static/media/office_lobby.28a1c1d1.jpg";